export default "__VITE_ASSET__ZpJMl7GY__"